<template>
  <modal v-model="modal" title="Logo Upload">
    <template #activator="{ on, attrs }">
      <qvoButton v-bind="attrs" v-on="on" outlined>Upload</qvoButton>
    </template>
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton @click="saveUpload">Done</qvoButton>
    </template>
    <v-file-input
      ref="fileInput"
      :value="file"
      @change="addFile"
      v-show="false"
    />
    <div class="content">
      <p class="subtitle-1">Upload a logo in the form of a .PNG or .PDF</p>
      <fileDisplay
        v-if="hasFile"
        :fileSource="getFile.file"
        :fileHeader="getFile.header"
        showCancelButton
        @removeFile="removeFile"
      />
      <div
        v-else
        class="drop-area"
        :class="readyToDrop && 'ready-to-drop'"
        @drop.prevent="addFileFromDrag"
        @dragover.prevent
        @dragenter="readyToDrop = true"
        @dragleave.prevent.self="readyToDrop = false"
        @click="openFilePicker"
      >
        <div class="drop-message">
          <v-icon size="128">mdi-upload-outline</v-icon>
          <p class="subtitle-1">.PNG .PDF</p>
          <p class="subtitle-1">Drag and drop your image here or</p>
          <qvoButton outlined>Choose File</qvoButton>
        </div>
      </div>
    </div>
  </modal>
</template>
  
<script>
import readFile from "@/util/readFileAsync";

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import modal from "@/qux-common/qux22/components/molecules/modal";

import fileDisplay from "./file-display";

export default {
  components: {
    qvoButton,
    modal,
    fileDisplay,
  },
  data() {
    return {
      modal: false,
      file: undefined,
      readyToDrop: false,
    };
  },
  methods: {
    closeModal() {
      this.removeFile();
      this.modal = false;
    },
    saveUpload() {
      this.$emit("setConfigValue", {
        fieldId: "FileName",
        value: this.getFile.basename,
      });
      this.$emit("setConfigValue", {
        fieldId: "FileSource",
        value: this.getFile.file,
      });
      this.$emit("setConfigValue", {
        fieldId: "FileType",
        value: this.getFile.extension,
      });
      this.modal = false;
    },
    addFile(file) {
      this.file = file;
    },
    addFileFromDrag(event) {
      this.readyToDrop = false;
      const { files } = event.dataTransfer;
      this.addFile(files[0]);
    },
    removeFile() {
      this.file = undefined;
    },
    openFilePicker() {
      this.$refs.fileInput.$refs.input.click();
    },
  },
  computed: {
    hasFile() {
      return !!this.file;
    },
  },
  asyncComputed: {
    async getFile() {
      if (this.file) {
        const { name } = this.file;
        const fileExtensionIndex = name.lastIndexOf(".");
        const basename = name.slice(0, fileExtensionIndex);
        const extension = name.slice(fileExtensionIndex + 1);

        const file = await readFile(this.file);
        const [header, data] = file.split(",");

        return { file, header, data, name, basename, extension };
      }
      return {};
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  p {
    color: $qvo-color-grey-700;
    margin-bottom: $qvo-spacing-24;
  }
  .v-icon {
    color: $qvo-color-blue-400;
  }
}
.drop-area {
  flex-grow: 1;
  border: 2px dashed $qvo-color-grey-400;
  border-radius: 8px;
  padding: $qvo-spacing-24;
  transition: background 300ms ease-in;
  p {
    color: $qvo-color-grey-500;
  }
  .drop-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
}
.ready-to-drop {
  background: $qvo-color-blue-200;
}
.file-display {
  margin: 0 auto;
}
</style>